<div [style.cursor]="show && data ? 'pointer' : 'default'" #anchor (click)="toggle()" fxLayout="column"
     fxLayoutAlign="center center" fxLayoutGap="5px">
  <div class="colored-circle"
       [style.backgroundColor]="bgColor"
       [style.color]="textColor">
    {{text}}
  </div>
  <span>{{label}}</span>
</div>

<kendo-popup
  #popup
  [anchor]="anchor"
  [anchorAlign]="anchorAlign"
  (anchorViewportLeave)="show = false"
  *ngIf="show && data">
  <div class='content'>

    <section class="k-border k-border-solid k-border-dark">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
        <span style="padding: 0 16px">{{label}}</span>
        <button mat-icon-button (click)="toggle()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </section>

    <section *ngIf="data && data.length > 0" fxLayout="column" fxLayoutAlign="center" style="padding: 10px 16px">
      <a href="#" (click)="onClick(item)" *ngFor="let item of data" fxLayout="column">
        <div fxLayout="row" fxLayoutGap="10px">
          <span>{{item.dateDeclenchement | date}}</span>
          <span>{{item.localisation}}</span>
        </div>
        <em>{{item.description}}</em>
      </a>
    </section>

    <section *ngIf="data && data.nomAction1" fxLayout="row" fxLayoutAlign="space-around center"
             style="padding: 10px 16px">
      <button mat-raised-button (click)="onActionClick(data.nomAction1)">{{data.nomAction1}}</button>
      <button mat-raised-button (click)="onActionClick(data.nomAction2)">{{data.nomAction2}}</button>
      <button mat-raised-button (click)="onActionClick(data.nomAction3)">{{data.nomAction3}}</button>
    </section>

  </div>
</kendo-popup>
